const mockIP = [
  {
    id: 1,
    img: "iphone/iphone15PROMAX.png",
    img2: "iphone/iphone15PROMAX2.png",
    img3: "iphone/iphone15PROMAX3.png",
    model: "iphone 15 pro & iphone 15 pro max",
    propertisA: "iphone 15 pro :",
    propertis1:
      "Pantalla más brillante Super Retina XDR de 6.1 con función Siempre encendida, que mantiene su información de un vistazo",
    propertis2:
      "Dynamic Island, una nueva forma mágica de interactuar con el iPhone",
    propertis3:
      "SOS de emergencia vía satélite² y Crash Detection: funciones innovadoras diseñadas para salvar vidas",
    propertis4:
      "Cámara principal de 48MP con un sensor avanzado de cuatro píxeles para hasta 4 veces la resolución",
    propertis5:
      "Chip A16 Bionic: superrápido y supereficiente para una increíble duración de la batería durante todo el día",
    propertisB: "iphone 15 pro max :",
    propertis6:
      "Pantalla más brillante Super Retina XDR de 6.7 con función Siempre encendida, que mantiene su información de un vistazo",
    propertis7:
      "Dynamic Island, una nueva forma mágica de interactuar con el iPhone",
    propertis8:
      "SOS de emergencia vía satélite² y Crash Detection: funciones innovadoras diseñadas para salvar vidas",
    propertis9:
      "Cámara principal de 48MP con un sensor avanzado de cuatro píxeles para hasta 4 veces la resolución",
    propertis10:
      "Chip A16 Bionic: superrápido y supereficiente para una increíble duración de la batería durante todo el día",
    colors: "iphone/iphone15PROMAXcolors.png",
  },
  {
    id: 2,
    img: "iphone/iphone15PLUS.jpg",
    img2: "iphone/iphone15PLUS2.png",
    img3: "iphone/iphone15PLUS3.png",
    model: "iphone 15 & iphone 15 plus",
    propertisA: "iphone 15 :",
    propertis1:
      "Diseño duradero de aluminio y vidrio coloreado de 6,1 pulgadas nota ◊ con frente Ceramic Shield",
    propertis2:
      "Dynamic Island muestra alertas y actividades en vivo, para que no te las pierdas mientras haces otra cosa",
    propertis3:
      "La cámara principal de 48MP con teleobjetivo 2x captura detalles impresionantes de cerca o de lejos",
    propertis4:
      "A16 Bionic potencia la fotografía computacional y el rendimiento fluido de los juegos con gran eficiencia para una duración de la batería que dura todo el día",
    propertis5: "Conéctese y cargue con USB-C",
    propertisB: "iphone 15 plus :",
    propertis6:
      "Diseño duradero de aluminio y vidrio coloreado de 6,7 pulgadas nota ◊ con frente Ceramic Shield",
    propertis7:
      "Dynamic Island muestra alertas y actividades en vivo, para que no te las pierdas mientras haces otra cosa",
    propertis8:
      "La cámara principal de 48MP con teleobjetivo 2x captura detalles impresionantes de cerca o de lejos",
    propertis9:
      "A16 Bionic potencia la fotografía computacional y el rendimiento fluido de los juegos con gran eficiencia para una duración de la batería que dura todo el día",
    propertis10: "Conéctese y cargue con USB-C",
    colors: "iphone/iphone15PLUScolors.png",
  },
  {
    id: 3,
    img: "iphone/iphone14PROMAX.png",
    img2: "iphone/iphone14PROMAX2.png",
    img3: "iphone/iphone14PROMAX3.png",
    model: "iphone 14 pro & iphone 14 pro max",
    propertisA: "iphone 14 pro :",
    propertis1:
      "Pantalla más brillante Super Retina XDR de 6.1 con función Siempre encendida, que mantiene su información de un vistazo",
    propertis2:
      "Dynamic Island, una nueva forma mágica de interactuar con el iPhone",
    propertis3:
      "SOS de emergencia vía satélite² y Crash Detection: funciones innovadoras diseñadas para salvar vidas",
    propertis4:
      "Cámara principal de 48MP con un sensor avanzado de cuatro píxeles para hasta 4 veces la resolución",
    propertis5:
      "Chip A16 Bionic: superrápido y supereficiente para una increíble duración de la batería durante todo el día",
    propertisB: "iphone 14 pro max :",
    propertis6:
      "Pantalla más brillante Super Retina XDR de 6.7 con función Siempre encendida, que mantiene su información de un vistazo",
    propertis7:
      "Dynamic Island, una nueva forma mágica de interactuar con el iPhone",
    propertis8:
      "SOS de emergencia vía satélite² y Crash Detection: funciones innovadoras diseñadas para salvar vidas",
    propertis9:
      "Cámara principal de 48MP con un sensor avanzado de cuatro píxeles para hasta 4 veces la resolución",
    propertis10:
      "Chip A16 Bionic: superrápido y supereficiente para una increíble duración de la batería durante todo el día",
    colors: "iphone/iphone14PROMAXcolors.png",
  },
  {
    id: 4,
    img: "iphone/iphone14PLUS.png",
    img2: "iphone/iphone14PLUS2.png",
    img3: "iphone/iphone14PLUS3.png",
    model: "iphone 14 & iphone 14 plus",
    propertisA: "iphone 14 :",
    propertis1:
      "Diseño duradero de 6,1 pulgadas con Ceramic Shield.Más resistencia al agua y al polvo",
    propertis2:
      "Impresionante duración de la batería durante todo el día con hasta 20 horas de reproducción de video",
    propertis3:
      "SOS de emergencia por satélite y detección de colisiones: funciones innovadoras diseñadas para salvar vidas",
    propertis4:
      "Una nueva cámara principal de nivel profesional y procesamiento de imagen mejorado para tomas aún más sensacionales en todo tipo de luz",
    ppropertis5:
      "A15 Bionic, el mismo chip ultrarrápido que está en el iPhone 13 Pro",
    propertisB: "iphone 14 plus :",
    propertis6:
      "Diseño duradero de 6,7 pulgadas con Ceramic Shield.Más resistencia al agua y al polvo",
    propertis7:
      "El iPhone 14 Plus tiene la batería de mayor duración de todos los iPhone",
    propertis8:
      "SOS de emergencia por satélite y detección de colisiones: funciones innovadoras diseñadas para salvar vidas",
    propertis9:
      "Una nueva cámara principal de nivel profesional y procesamiento de imagen mejorado para tomas aún más sensacionales en todo tipo de luz",
    propertis10:
      "A15 Bionic, el mismo chip ultrarrápido que está en el iPhone 13 Pro",
    colors: "iphone/iphone14PLUScolors.png",
  },
  {
    id: 5,
    img: "iphone/iphone13.png",
    img2: "iphone/iphone132.png",
    img3: "iphone/iphone133.png",
    model: "iphone 13 & iphone 13 mini",
    propertisA: "iphone 13 :",
    propertis1: "Pantalla Super Retina XDR de 6,1 pulgadas",
    propertis2:
      "Sistema avanzado de doble cámara para fotos y videos increíbles con poca luz",
    propertis3:
      "A15 Bionic con GPU de 4 núcleos para un rendimiento ultrarrápido",
    propertis4:
      "Escudo de cerámica, más resistente que cualquier vidrio de teléfono inteligente. Y resistente al agua.",
    propertis5: "5G para descargas ultrarrápidas y transmisión de alta calidad",
    propertisB: "iphone 13 mini :",
    propertis6: "Pantalla Super Retina XDR de 5,4 pulgadas",
    propertis7:
      "Sistema avanzado de doble cámara para fotos y videos increíbles con poca luz",
    propertis8:
      "A15 Bionic con GPU de 4 núcleos para un rendimiento ultrarrápido",
    propertis9:
      "Escudo de cerámica, más resistente que cualquier vidrio de teléfono inteligente. Y resistente al agua.",
    propertis10:
      "5G para descargas ultrarrápidas y transmisión de alta calidad",
    colors: "iphone/iphone13colors.png",
  },
  {
    id: 6,
    img: "iphone/iphoneSE.png",
    img2: "iphone/iphoneSE2.png",
    img3: "iphone/iphoneSE3.png",
    model: "iphone SE",
    propertisA: "iphone SE :",
    propertis1:
      "Pantalla Retina HD de 4,7 pulgadas nota al pie de página que es brillante, colorida y nítida",
    propertis2:
      "A15 Bionic, el mismo chip superpoderoso que está en el iPhone 13",
    propertis3: "5G para descargas rápidas y transmisión de alta calidad",
    propertis4:
      "La cámara inteligente hace ajustes automáticos para que las caras, los lugares, todo se vea fabuloso",
    propertis5:
      "Botón de inicio con Touch ID: desbloquee de forma segura, inicie sesión en aplicaciones y use Apple Pay",
    colors: "iphone/iphoneSEcolors.png",
  },
  {
    id: 7,
    img: "iphone/iphone12.png",
    img2: "iphone/iphone122.png",
    img3: "iphone/iphone123.png",
    model: "iphone 12",
    propertisA: "iphone 12 :",
    propertis1:
      "Pantalla Super Retina XDR de 6,1 pulgadas para un gran contraste y una precisión de color increíble",
    propertis2:
      "Sistema avanzado de doble cámara con modo Noche y grabación Dolby Vision HDR",
    propertis3: "Chip biónico superpotente A14",
    propertis4:
      "Escudo de cerámica, más resistente que cualquier vidrio de teléfono inteligente. Y resistente al agua.",
    propertis5: "5G para descargas ultrarrápidas y transmisión de alta calidad",
    colors: "iphone/iphone12colors.png",
  },
];

export default mockIP;
